export class ValidateError extends Error {
  constructor(
    message: string,
    public path: string[],
    public value: any,
  ) {
    super(message + ': ' + path.join('.'));
  }
}
